import { render, staticRenderFns } from "./CardAnalyticProductOrders.vue?vue&type=template&id=331bfe52&"
import script from "./CardAnalyticProductOrders.vue?vue&type=script&lang=js&"
export * from "./CardAnalyticProductOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports